import { FC } from 'react';
import styled from 'styled-components';
import ControlErrorMessages from 'ia-react-core/~/components/message/ControlErrorMessages';

export const StyledErrorMessages = styled(ControlErrorMessages)<{ errorsMarginTop: string }>`
  position: relative;
  margin-top: ${({ errorsMarginTop }) => errorsMarginTop || '-1px'};
` as typeof ControlErrorMessages & FC<{ errorsMarginTop: string }>;
